import restApi from './congressApiService'

const congressService = {}

congressService.getAll = () => {
  return restApi.get(`/congresses`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      throw new Error(err)
    })
}

congressService.getOne = (id) => {
  return restApi.get(`/congresses/${id}`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      throw new Error(err)
    })
}

congressService.getOneByCode = (congressCode) => {
  return restApi.get(`/congresses/byCode/${congressCode}`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      throw new Error(err)
    })
}

congressService.getHotelById = (hotelId) => {
  return restApi.get(`/hotel/${hotelId}`)
    .then((res) => {
      return res.data
    })
    .catch((err) => {
      throw new Error(err)
    })
}

export default congressService
